import { Dataset } from '~/packages/general/system/bulk/systemBulk.data'
import { parseCsvLocalDateTime, parseEnumEmptyString } from '~/prix/utils/bulk/csvValueParsers'

const healthcareReferral: Dataset = {
  schema: 'public_health',
  table: 'healthcare_referral',
  columnTransformMap: {
    original_id: original => original,
    data_source_id: original => original,
    attendance_original_id: original => original,
    referral_specialty: original => parseEnumEmptyString(original as string),
    risk_classification: original => parseEnumEmptyString(original as string),
    icd10_code: original => original,
    icpc2_code: original => original,
    created_at: original => parseCsvLocalDateTime(original as string),
    updated_at: original => parseCsvLocalDateTime(original as string),
  },
}

export default healthcareReferral
